import { useCallback } from 'preact/hooks';
import useBotRequest from '@components/chatbots/twitch/data/useBotRequest.js';


export function useGetWebhooks({
  twitchUsername,
  twitchAccessToken,
  twitchTokenValidated,
}) {
  const handleBotRequest = useBotRequest({ twitchUsername, twitchAccessToken });

  return useCallback(async () => {
    const url = import.meta.env.VITE_BOT_URL + '/getWebhooks';

    if (!twitchAccessToken || !twitchTokenValidated) {
      return { success: false, webhooks: null };
    }

    const { data: webhooks, success } = await handleBotRequest(url);


    return { success, webhooks };
  }, [
    handleBotRequest,
    twitchAccessToken,
    twitchTokenValidated,
  ]);
}


